import NetInfo from '@react-native-community/netinfo';
import { AppState } from 'react-native';
import { focusManager, onlineManager, QueryClient } from '@tanstack/react-query';

// ✅ React Native fix: React Query uses window.addEventListener('online') by default which
// doesn't exist in React Native. We must hook it up to NetInfo manually.
onlineManager.setEventListener((setOnline) => {
  return NetInfo.addEventListener((state) => {
    setOnline(!!state.isConnected && state.isInternetReachable !== false);
  });
});

// ✅ React Native fix: React Query uses document visibility API by default which doesn't
// exist in React Native. We must hook it up to AppState manually.
function onAppStateChange(status: string) {
  if (status === 'active') {
    focusManager.setFocused(true);
  } else if (status === 'background' || status === 'inactive') {
    focusManager.setFocused(false);
  }
}

AppState.addEventListener('change', onAppStateChange);

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000, // 30s — data considered fresh
      gcTime: 5 * 60_000, // 5min — unused data kept in memory
      retry: 2,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 10_000), // 1s, 2s, 4s... capped at 10s
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 1,
    },
  },
});
